import { type Accessor, createEffect, createSignal, onCleanup } from "solid-js";

/**
 * Open/close state for a menu-style popover: Escape closes and refocuses the
 * trigger; an optional body class mirrors the open state (mobile-nav scroll
 * lock).
 */
export function createDismissable(options?: { bodyClass?: string }): {
  open: Accessor<boolean>;
  setOpen: (value: boolean) => void;
  toggle: () => void;
  close: () => void;
  setTrigger: (element: HTMLButtonElement) => void;
} {
  const [open, setOpen] = createSignal(false);
  let trigger: HTMLButtonElement | undefined;
  const close = () => {
    setOpen(false);
    queueMicrotask(() => trigger?.focus());
  };
  createEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape" && open()) {
        close();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    if (options?.bodyClass) {
      document.body.classList.toggle(options.bodyClass, open());
    }
    onCleanup(() => {
      document.removeEventListener("keydown", onKeyDown);
      if (options?.bodyClass) {
        document.body.classList.remove(options.bodyClass);
      }
    });
  });
  return {
    open,
    setOpen,
    toggle: () => setOpen(!open()),
    close,
    setTrigger: (element) => {
      trigger = element;
    },
  };
}
